import { render, staticRenderFns } from "./CreditScoreIcon.vue?vue&type=template&id=45c10620&scoped=true&"
import script from "./CreditScoreIcon.vue?vue&type=script&lang=js&"
export * from "./CreditScoreIcon.vue?vue&type=script&lang=js&"
import style0 from "./CreditScoreIcon.vue?vue&type=style&index=0&id=45c10620&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c10620",
  null
  
)

component.options.__file = "CreditScoreIcon.vue"
export default component.exports